/**
 * The expand/minimize animation's steps amount.
 * @type {Number}
 */
export const ANIMATION_STEP_AMOUNT = 12;
